namespace NasVault {
  export const state = {
    currentPath: "/",
    loaded: false,
    loading: false,
    rootFolders: [] as Item[],
    currentItems: [] as Item[],
    pendingFiles: [] as File[],
    dragDepth: 0,
    deleteTarget: null as Item | null,
    canWrite: false,
    deleteEnabled: false,
  };

  export const element = <T extends HTMLElement = HTMLElement>(id: string): T | null =>
    document.getElementById(id) as T | null;

  export const joinPath = (base: string, name: string): string =>
    `${base.replace(/\/$/, "")}/${name}`;

  export function sizeLabel(bytes: number): string {
    if (bytes === 0) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  }
}
